export default {
    'FlujoEtapa.EtapaActual': 'Etapa Actual',
    'FlujoEtapa.EtapaSiguiente': 'Etapa Siguiente',
    'FlujoEtapa.Estado': 'Estado',
    'FlujoEtapa.Guardar': 'Guardar',
    'FlujoEtapa.Editar': 'Editar',
    'FlujoEtapa.EtapasIguales': 'La etapa actual y la Etapa siguiente no pueden ser la misma ',
};
